import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label
} from 'recharts'
import ReactResizeDetector from 'react-resize-detector'
import _ from 'lodash'
import { numeralFormat } from '../../../../../../lib/renderUtil'
import ComposeChartModule from '../../../../Common/NewDashboard/Chart/BaseChartModule/ComposeChart/ComposeChart'
import CustomizeXAxisTick from '../../ReturnsAnalysis/ReturnsChart/CustomizeXAxisTick/CustomizeXAxisTick'
import CustomizedLegend from '../../../../Common/NewDashboard/Chart/Legend/Legend'
import YAxisLabel from '../../../../Common/NewDashboard/Chart/YAxisLabel/YAxisLabel'
import LineDot from '../../../../Common/NewDashboard/Chart/LineDot/LineDot'
import {
  ChartToolTip,
  Title,
  Item,
  ItemIcon
} from '../../../../Common/NewDashboard/Chart/ToolTip'
import {
  getDashboardDateTime,
  DATE_FORMAT
} from '../../../../../lib/MomentHelper'
import styles from './TrendCharts.css'

export const FIELD = {
  REPORT_DATE: 'reportDate',
  memberQuantity: 'memberQuantity',
  newMemberQuantity: 'newMemberQuantity',
  returnMemberQuantity: 'returnMemberQuantity'
}

class TrendCharts extends ComposeChartModule {
  constructor () {
    super()
    this.state = {}
  }

  render () {
    const { data } = this.props
    const isMember = _.get(data, `[0][${FIELD.memberQuantity}]`, 0) > 0
    const isNewMember = _.get(data, `[0][${FIELD.newMemberQuantity}]`, 0) > 0
    const isReturnMember = _.get(data, `[0][${FIELD.returnMemberQuantity}]`, 0) > 0
    return (
      <div className={styles.chartBlock}>
        <ReactResizeDetector
          handleWidth
          handleHeight
          onResize={this.updateChartWidth}
        />
        <ResponsiveContainer
          width='100%'
          height='100%'
          minHeight='250px'
        >
          <ComposedChart
            ref={this.initChart}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }}
          >
            <XAxis
              tickLine={false}
              dataKey={FIELD.REPORT_DATE}
              tick={<CustomizeXAxisTick />}
            />
            <YAxis
              yAxisId='left'
              axisLine={false}
              tickLine={false}
            >
              <Label
                value='數量'
                offset={20}
                position='left'
                angle={-90}
                content={<YAxisLabel />}
              />
            </YAxis>
            <CartesianGrid
              vertical={false}
              stroke='#f5f5f5'
            />
            <Tooltip
              cursor={{
                stroke: '#eee',
                strokeWidth: this.state.tooltipCursorWidth
              }}
              content={<CustomizedTooltip />}
            />
            <Legend
              align='left'
              verticalAlign='top'
              wrapperStyle={{
                top: '-40px',
                color: '#9aa0ab'
              }}
              content={<CustomizedLegend />}
            />
            {isMember && (
              <Line
                name='會員數'
                yAxisId='left'
                dataKey={FIELD.memberQuantity}
                stroke='#6a96f3'
                strokeWidth='2'
                activeDot={false}
                dot={<LineDot />}
              />
            )}
            {isNewMember && (
              <Line
                name='新客數'
                yAxisId='left'
                dataKey={FIELD.newMemberQuantity}
                stroke='#4CD8A3'
                strokeWidth='2'
                activeDot={false}
                dot={<LineDot />}
              />
            )}
            {isReturnMember && (
              <Line
                name='回客數'
                yAxisId='left'
                dataKey={FIELD.returnMemberQuantity}
                stroke='#EB2B76'
                strokeWidth='2'
                activeDot={false}
                dot={<LineDot />}
              />
            )}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    )
  }
}

const CustomizedTooltip = props => {
  const { active, payload = [], label: reportDate } = props
  if (active) {
    return (
      <ChartToolTip>
        <Title>
          {getDashboardDateTime(reportDate, DATE_FORMAT.LINE_CHART_X_AXIS_DATE)}
        </Title>
        {payload.map((item, itemIndex) => {
          const { stroke, name, value } = item
          return (
            <Item
              key={itemIndex}
            >
              <ItemIcon color={stroke} />
              {`${name}：${numeralFormat(value, { allowZero: true })}`}
            </Item>
          )
        })}
      </ChartToolTip>
    )
  }
  return null
}

export default TrendCharts
